<script setup lang="ts">
/** Badge de statut — icône + couleur + label (jamais couleur seule, cf MASTER §1). */
import { computed, type Component } from 'vue'
import {
  InboxArrowDownIcon,
  UserPlusIcon,
  BoltIcon,
  TrophyIcon,
  HandThumbDownIcon,
  XCircleIcon,
} from '@heroicons/vue/24/outline'
import type { AccompStatus } from '@/v2/accompagnement/api/accompagnementTypes'
import { ACCOMP_STATUS_META } from '@/v2/accompagnement/constants/accompagnementConstants'

const props = defineProps<{ status: AccompStatus }>()

const ICONS: Record<AccompStatus, Component> = {
  NOUVELLE: InboxArrowDownIcon,
  ATTRIBUEE: UserPlusIcon,
  EN_COURS: BoltIcon,
  GAGNEE: TrophyIcon,
  PERDUE: HandThumbDownIcon,
  ANNULEE: XCircleIcon,
}

const meta = computed(() => ACCOMP_STATUS_META[props.status])
const icon = computed(() => ICONS[props.status])
</script>

<template>
  <span class="badge badge-sm gap-1 whitespace-nowrap" :class="meta.badgeClass">
    <component :is="icon" class="h-3.5 w-3.5" aria-hidden="true" />
    {{ meta.label }}
  </span>
</template>
